import StockTradingAnalyzer from './components/StockTradingAnalyzer';

function App() {
  return <StockTradingAnalyzer />;
}

export default App;